export default __webpack_public_path__ + "static/media/190629_190332_Joe & Michael 3 JPEG.ac706653.jpg";